import React, { useState, useEffect, useContext } from 'react';
import styles from './HanpickedSafaris.module.scss';
import { Link } from "@tanstack/react-router";
import { getRouteApi } from '@tanstack/react-router';
import { DestinationContext } from '../../../contexts/DestinationContext';
import EntryCard from '../EntryCard';
import isEmpty from 'lodash.isempty';

const routeApi = getRouteApi('/');

const Handpickedsafaris = () => {
  const { safaris } = routeApi.useLoaderData()
  const destination = useContext(DestinationContext);

  return (
    !isEmpty(safaris) && (
      <div className={styles.container} id="handpicked-safaris">
        <div className={styles['main-wrapper']}>
          <div className={styles['main-content']}>
            <div className={styles['main-top-content']}>
              <div className={styles['main-top-content__title']}>
                <span className={styles['eyebrow']}>Real Safaris, Ready to Book</span>
                <h1>Safaris in {destination.name}</h1>
                <p>
                  We selected the top safaris to ensure you experience
                  only the very best.
                </p>
              </div>
              <div className={styles['main-top-content__clickables']}>
                <div className={styles['clickables']}>
                  <Link
                    to="/safaris"
                    className={styles['main-top-content__tag']}
                  >
                    View All Safaris
                  </Link>
                </div>
              </div>
            </div>
            <div className={styles['main-card-content']}>
              {safaris.map(safari => {
                return (
                  <div key={safari._id}>
                    <EntryCard
                      entry={safari}
                      isProperty={false}
                      isSmall={true}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default Handpickedsafaris;
